import axios from "axios"
import {
	// getWithExpiry,
	setObjectLocalStorageCondition
} from "./localStorageExpire"
import router from "../router/index"
import store from "../store/index"
// import store from "../store/index"
const { VUE_APP_API_BASE_URL } = process.env

const instance = axios.create({
	baseURL: VUE_APP_API_BASE_URL
})

export const protectedAxiosInstance = axios.create({
	baseURL: VUE_APP_API_BASE_URL
})

protectedAxiosInstance.interceptors.request.use(
	(request) => {
		request.headers.Authorization =
			"Bearer " + localStorage.getItem("accessId")
		return request
	},
	() => {}
)

protectedAxiosInstance.interceptors.response.use(
	async (response) => {
		if (!response.data.success) {
			return Promise.reject(response)
		}
		return response
	},
	async function(error) {
		const originalRequest = error.config
		if (
			(error.response.status === 403 || error.response.status === 401) &&
			!originalRequest._retry
		) {
			const refreshId = localStorage.getItem("refreshId")
			originalRequest._retry = true
			try {
				const {
					data: { success, tokens }
				} = await instance.post("/auth/refresh-tokens", {
					refreshId
				})
				setObjectLocalStorageCondition(tokens, success)
				return await protectedAxiosInstance(originalRequest)
			} catch (err) {
				router.push({ name: "login" })
				return Promise.reject(err)
			}
		}
		store.commit("SET_AUTHENTICATED", false)
		router.push({ name: "login" })
		return Promise.reject(error)
	}
)

export default instance
